export const globalItems = [
  { id: "header", name: "mell.globalItems.header", icon: "header" },
  { id: "footer", name: "mell.globalItems.footer", icon: "footer" },
  { id: "menu", name: "mell.globalItems.menu", icon: "menu" },
  { id: "mobileBar", name: "mell.globalItems.mobileBar", icon: "mobile" },
  { id: "socials", name: "mell.globalItems.socials", icon: "share" },
  { id: "support", name: "mell.globalItems.support", icon: "support" },
]

export const globalItemsMeta = {
  header: { name: "mell.globalItemsMeta.header.name", description: "mell.globalItemsMeta.header.description" },
  footer: { name: "mell.globalItemsMeta.footer.name", description: "mell.globalItemsMeta.footer.description" },
  menu: { name: "mell.globalItemsMeta.menu.name", description: "mell.globalItemsMeta.menu.description" },
  mobileBar: { name: "mell.globalItemsMeta.mobileBar.name", description: "mell.globalItemsMeta.mobileBar.description" },
  socials: { name: "mell.globalItemsMeta.socials.name", description: "mell.globalItemsMeta.socials.description" },
  support: { name: "mell.globalItemsMeta.support.name", description: "mell.globalItemsMeta.support.description" },
}

export const headerComponents = {
  left: [],
  right: [
    { key: "accountButtons", label: "mell.headerComponents.accountButtons" },
    { key: "notifications", label: "mell.headerComponents.notifications" },
  ],
}

export const socialNetworks = [
  { key: "instagram", label: "mell.socialNetworks.instagram" },
  { key: "telegram", label: "mell.socialNetworks.telegram" },
  { key: "vk", label: "mell.socialNetworks.vk" },
]

export const supportNetworks = [
  { key: "whatsapp", label: "Whatsapp" },
  { key: "email", label: "Email", icon: "email" },
  { key: "telegram", label: "mell.socialNetworks.telegram" },
  { key: "vk", label: "mell.socialNetworks.vk" },
  { key: "kyc_email", label: "KYC Email" },
]
